// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__jaOZJ","warning":"label_warning__1EzX1"};